import { render, staticRenderFns } from "./CouponRuleCpps.vue?vue&type=template&id=5fefa418&scoped=true"
import script from "./CouponRuleCpps.vue?vue&type=script&lang=js"
export * from "./CouponRuleCpps.vue?vue&type=script&lang=js"
import style0 from "./CouponRuleCpps.vue?vue&type=style&index=0&id=5fefa418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fefa418",
  null
  
)

export default component.exports